export const BRAND_NAME = 'Babu777com';
// Note: It is the main site url. Ex - Babu777com.com, etc.
export const BRAND_DOMAIN = 'babu777.com';
// Note: It is the main site url. Ex - playnetgaming.net, etc.
export const BRAND_DOMAIN_SKIN_URL = 'babu777.com';
export const PROVIDER = 'BetFair';
export const PROVIDER_ID = 'BetFair';
export const BACKEND_DOMAIN = 'cue88.com';